import React from 'react';
import styles from './TextSection.module.css';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const TextSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <OptimizedMotionH2 type="slide-down" delay={0.1} className={styles.title}>
                Templates Tailored to <br />
                Your Industry
            </OptimizedMotionH2>
            <OptimizedMotionP type="slide-right" delay={0.4} className={styles.text}>
                Thirty‑plus pre‑built layouts—SaaS launch decks, CPG promo carousels, fintech
                explainer videos—come loaded with best‑practice content blocks and channel‑specific
                dimensions. Customize in minutes, hit "Approve," and watch the system auto‑schedule
                across every channel.
            </OptimizedMotionP>
            <div className={styles.blur1}></div>
            <div className={styles.blur2}></div>
        </div>
    );
};

export default TextSection;
